import moment from 'moment';
import t from './Submit.type';
import * as SubmitDownloadService from '../../../../services/submit-download.service';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { ERROR_MESSAGE, SUBMIT_DOWNLOAD, imageUrl, downloadFileFromUrl, downloadUrlsAsZip, hasOnlyLegacyFilePaths } from '../../../../Components/helper';
import { rememberPendingDownload } from '../pending-downloads';

export const getPoByDevorderSupplier = (params) => async () => {
  try {
    const res = await SubmitDownloadService.getPoByDevorderSupplier(params);
    if (res?.code === 200) {
      return res.data.pos;
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getFilteredPOs = (params) => async () => {
  try {
    const res = await SubmitDownloadService.getFilteredPOs(params);
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg('Failed to load Purchase Orders', 'danger');
    return [];
  } catch (err) {
    console.error('❌ getFilteredPOs API error:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
    throw err;
  }
};

export const getBulkFilteredPOs = (params) => async (dispatch) => {
  try {
    const res = await SubmitDownloadService.getBulkFilteredPOs(params);
    if (res?.code === 200) {
      dispatch({
        type: t.GET_BULK_FILTERED_POS,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg('Failed to load Purchase Orders', 'danger');
    return [];
  } catch (err) {
    console.error('❌ getBulkFilteredPOs API error:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
    throw err;
  }
};
const downloadFile = async (res) => {
  if (res?.data?.fileName || res?.data?.zipName) {
    const fileName = res.data.fileName ? res.data.fileName.toString() : res.data.zipName;

    try {
      const downloaded = await downloadFileFromUrl(res.data.zipUrl, fileName);
      if (!downloaded) {
        toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        return;
      }
      toasterMsg('Pdf build successfully', 'success');
    } catch (error) {
      console.error('Download error:', error);
      toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
    }
  }
};
export const requestSampleMultiProducts = (params) => async () => {
  try {
    const res = await SubmitDownloadService.requestSampleMultiProducts(params);
    if (res?.code === 200) {
      const msg = typeof res?.message === 'string' && res.message ? res.message : 'Sample request saved successfully.';
      toasterMsg(msg, 'success');
      return 200;
    }
    toasterMsg(res?.data?.errMsg || ERROR_MESSAGE, 'danger');
    return res?.code;
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Asks for a submit-download and returns as soon as the server has accepted it.
 *
 * The file is not ready yet: the server answers with a request id and sends the finished archive
 * over `submit-download-ready`, which socket.js turns into the actual download. The id is kept so
 * a tab that misses that event can ask for the result instead of waiting on it forever.
 */
export const requestOrderSubmitDownload = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.createSubmitDownloadRequest(params);
    if (res?.code === 202 && res?.data?.requestId) {
      if (!rememberPendingDownload(res.data.requestId)) {
        toasterMsg(trans('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.DOWNLOAD_NOT_RESUMABLE'), 'warning');
      }
      return res.data.requestId;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  } catch (err) {
    const status = err?.response?.status;
    const serverMessage = status >= 400 && status < 500 ? err?.response?.data?.message : undefined;
    toasterMsg(serverMessage ? trans(serverMessage) : ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const orderSubmitDownload = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.orderSubmitDownload(params);
    if (res?.code === 200) {
      downloadFile(res);
      if (res?.data?.blankDetails && Object.keys(res?.data?.blankDetails).length > 0) {
        const keyMapping = {
          bom: 'Bill of Materials',
          testing: 'Testing',
          care: 'Care/User Instructions',
          'care-label-layout': 'Care/User Instructions Layout',
          'test-report': 'Testing Reports',
          'design-details': 'Design/Details',
          measurement: 'Specifications',
        };
        const missingEntries = Object.keys(res?.data?.blankDetails)
          .map((key) => keyMapping[key] || key)
          .join(', ');
        const paragraph = `This product has no entry or the module is switched off in the following module(s): ${missingEntries}`;
        toasterMsg(paragraph, 'danger');
      }
    } else if (res?.data?.errMsg === 'FILE_NOT_EXISTS') {
      toasterMsg(trans(SUBMIT_DOWNLOAD.FILE_NOT_EXISTS), 'danger');
    } else if (res?.data?.errMsg === 'GRAD_GROUPS_SWITCH_OFF') {
      toasterMsg(trans(SUBMIT_DOWNLOAD.GRAD_GROUPS_SWITCH_OFF), 'danger');
    } else if (res?.data?.errMsg.includes('product')) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMeasurementDocuments = (data) => async () => {
  try {
    const res = await SubmitDownloadService.getMeasurementDocuments(data);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPoDocuments = (data) => async () => {
  try {
    const res = await SubmitDownloadService.getPoDocuments(data);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getBOMSUDocuments = (data) => async () => {
  try {
    const res = await SubmitDownloadService.getBOMSUDocuments(data);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const sendSupplierEmail = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.sendSupplierEmail(params);
    if (res && res.code === 200) {
      const successKey = res?.data?.isNotificationOnly
        ? 'DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.NOTIFICATION_SENT'
        : 'PDF file sent to supplier successfully.';
      toasterMsg(trans(successKey), 'success');
      return res.code;
    }
    if (res?.data?.errMsg === 'FILE_NOT_EXISTS') {
      toasterMsg(trans(SUBMIT_DOWNLOAD.FILE_NOT_EXISTS), 'danger');
    } else if (res?.data?.errMsg === 'GRAD_GROUPS_SWITCH_OFF') {
      toasterMsg(trans(SUBMIT_DOWNLOAD.GRAD_GROUPS_SWITCH_OFF), 'danger');
    } else if (res?.data?.errMsg === 'SWITCH_OFF') {
      toasterMsg(trans(SUBMIT_DOWNLOAD.SWITCH_OFF), 'danger');
    } else if (res?.data?.errMsg.includes('product')) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSubmitDOwnloadLogs = (params) => async (dispatch) => {
  try {
    const res = await SubmitDownloadService.getSubmitDownloadLog(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SUBMIT_DOWNLOAD_LOG,
        payload: res.data,
      });
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getDownloadLogs = (params) => async (dispatch) => {
  try {
    const res = await SubmitDownloadService.getDownloadLog(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.DOWNLOAD_LOG,
        payload: res.data,
      });
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const activeInactiveSubmitLogs = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.activeInactiveSubmitLog(params);
    if (res && res.code === 200) {
      toasterMsg(trans(res.message), 'success');
    } else {
      toasterMsg(trans(res.data.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const downloadFiles = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.downloadFiles(params);
    if (res?.code === 200) {
      if (res?.data?.zipName) {
        const fileName = res.data.zipName.toString();
        const fileUrl = res.data.zipUrl?.startsWith('http') ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

        const downloaded = await downloadFileFromUrl(fileUrl, fileName);
        if (!downloaded) {
          toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        }
      }
    } else {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteSubmitLogs = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.deleteSubmitLog(params);
    if (res && res.code === 200) {
      toasterMsg(trans(res.message), 'success');
    } else {
      toasterMsg(trans(res.data.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const deleteDownloadLogs = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.deleteDownloadLog(params);
    if (res && res.code === 200) {
      toasterMsg(trans(res.message), 'success');
    } else {
      toasterMsg(trans(res.data.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Downloads the files recorded on a download log entry.
 * Multi-file logs normally serve the zip the server already built; older logs and any log whose zip
 * was never produced have an empty zipFiles, so the bundle is assembled client-side from the file
 * URLs instead. Single-file logs always download that file directly rather than zipping it.
 * @param {object} params Download log entry, plus timeZone.
 * @param {Function} trans i18n translate function.
 * @returns {Function} Thunk resolving once the download has been triggered.
 */
export const downloadS3LogFiles = (params, trans) => async () => {
  try {
    const files = params?.files || [];
    const serverZipUrl = params?.zipFiles?.[0]?.zipUrl;

    if (!serverZipUrl && hasOnlyLegacyFilePaths(params)) {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_MISSING, 'danger');
      return;
    }

    if (files.length > 1 && !serverZipUrl) {
      const zipName = params?.zipFiles?.[0]?.zipName || `Document Pack - ${moment(params?.createdAt).format('DD-MM-YYYY - HH-mm')}`;
      const { downloaded, skippedCount } = await downloadUrlsAsZip(files, zipName);

      if (!downloaded) {
        toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        return;
      }
      if (skippedCount) {
        toasterMsg(`${skippedCount} of ${files.length} files were unavailable and are not in the zip.`, 'warning');
      }
      return;
    }

    let fileUrl = files?.[0]?.path;
    fileName = files?.[0]?.filename;
    if (files.length > 1) {
      fileName = params?.zipFiles?.[0]?.zipName;
      fileUrl = serverZipUrl;
    }

    const downloaded = await downloadFileFromUrl(fileUrl, fileName);
    if (!downloaded) {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
    }
  } catch (error) {
    console.error('Download error:', error);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const downloadLogFiles = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.downloadLogFiles(params);
    if (res?.code === 200) {
      if (res?.data?.zipName) {
        const fileName = res.data.zipName.toString();
        const fileUrl = res.data.zipUrl?.startsWith('http') ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

        const downloaded = await downloadFileFromUrl(fileUrl, fileName);
        if (!downloaded) {
          toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        }
      }
    } else {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getsupplierUser = (params) => async () => {
  try {
    const res = await SubmitDownloadService.getsupplierUser(params);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const requestForDownload = async (params) => {
  try {
    const res = await SubmitDownloadService.requestForDownload(params);
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const retriveSubmitLog = async (params) => {
  try {
    const res = await SubmitDownloadService.retriveSubmitLog(params);
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const downloadFromLinkLogZip = async (params) => {
  try {
    const res = await SubmitDownloadService.downloadFromLinkLogZip(params);
    if (res?.code === 200) {
      if (res?.data?.zipName) {
        const fileName = res.data.zipName.toString();
        const fileUrl = res.data.zipUrl?.startsWith('http') ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

        const downloaded = await downloadFileFromUrl(fileUrl, fileName);
        if (!downloaded) {
          toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        }
      }
    } else {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Downloads the zip for a group of submit logs opened from an emailed link.
 * Legacy logs are rejected up front: their file paths are not S3 keys, so the server can only answer
 * with a generic failure, and the specific reason would be lost.
 * @param {Array<object>} params Submit log entries in the group.
 * @param {string} timeZone Viewer time zone, used for the zip name.
 * @returns {Promise<void>} Resolves once the download has been triggered.
 */
export const multidownloadFromLinkLogZip = async (params, timeZone) => {
  try {
    if (hasOnlyLegacyFilePaths(params)) {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_MISSING, 'danger');
      return;
    }

    const res = await SubmitDownloadService.multidownloadFromLinkLogZip(params, timeZone);
    if (res?.code === 200) {
      if (res?.data?.zipName) {
        const fileName = res.data.zipName.toString();

        const downloaded = await downloadFileFromUrl(res.data.zipUrl, fileName);
        if (!downloaded) {
          toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        }
      }
    } else {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Downloads the zip for a group of download logs.
 * Legacy logs are rejected up front for the same reason as multidownloadFromLinkLogZip.
 * @param {Array<object>} params Download log entries in the group.
 * @param {string} timeZone Viewer time zone, used for the zip name.
 * @returns {Promise<void>} Resolves once the download has been triggered.
 */
export const multipleDownload = async (params, timeZone) => {
  try {
    if (hasOnlyLegacyFilePaths(params)) {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_MISSING, 'danger');
      return;
    }

    const res = await SubmitDownloadService.multipleDownload(params, timeZone);
    if (res && res.code === 200) {
      if (res?.data?.zipName) {
        const fileName = res.data.zipName.toString();

        const downloaded = await downloadFileFromUrl(res.data.zipUrl, fileName);
        if (!downloaded) {
          toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
        }
      }
    } else {
      toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMultiSubmitDownloadLogs = async (params) => {
  try {
    const res = await SubmitDownloadService.getMultiSubmitDownloadLogs(params);
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteMultiSubmitLogs = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.deleteMultiSubmitLogs(params);
    if (res && res.code === 200) {
      toasterMsg(trans(res.message), 'success');
    } else {
      toasterMsg(trans(res.data.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMultiDownloadLogs = async (params) => {
  try {
    const res = await SubmitDownloadService.getMultiDownloadLogs(params);
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg(SUBMIT_DOWNLOAD.FILE_NOT_AVAILABLE, 'danger');
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteMultiDownloadLogs = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.deleteMultiDownloadLogs(params);
    if (res?.code === 200) {
      toasterMsg(trans(res.message), 'success');
    } else {
      toasterMsg(trans(res.data.errMsg), 'danger');
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const downloadByUpdate = (params, trans) => async () => {
  try {
    const res = await SubmitDownloadService.downloadByUpdate(params);
    if (res?.code !== 200) {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
